import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { personInternalApi } from '../apis';
import { PersonSearchQuery } from './PersonSearch';
import { saveEntitySearchEvent } from '../tracking/userEventTracker';

const DEFAULT_PAGE_SIZE = 20;

export const useQueryPersons = (personSearchQuery: PersonSearchQuery) => {
  return useQuery({
    placeholderData: keepPreviousData,
    queryKey: ['persons', JSON.stringify(personSearchQuery)],
    queryFn: async () => {
      const sanitizedQuery = {
        ...personSearchQuery,
        filters: personSearchQuery.filters.map((filter) => ({
          ...filter,
          query: undefined,
        })),
      };
      saveEntitySearchEvent(sanitizedQuery);
      return personInternalApi.findAllPersonsInternal({
        internalApiPersonSearchQuery: {
          ...personSearchQuery,
          size: DEFAULT_PAGE_SIZE,
        },
      });
    },
  });
};
